export default [

    {
        path: '',
        name: 'dashboard-o',
        component: () => import('@/aplicacao/modulos/dashboard-o/Dashboard'),
        meta: { autenticacao: true },
    },

]
